export const peopleSelectTable = function (isPanel = false, isSelect = false) {
  return {
    selection: isSelect,
    index: true,
    indexLabel: "序号",
    maxHeight: "100%",
    column: [
      {
        label: "姓名",
        prop: "name",
        search: true,
        clearable: true
      },
      {
        label: "性别",
        prop: "sex",
        formatter: function (row, value) {
          if (Number(value) === 0) {
            return "女";
          } else if (Number(value) === 1) {
            return "男";
          } else if (Number(value) === 2) {
            return "未知";
          }
          return "";
        }
      },
      {
        label: "电话",
        prop: "phone",
      },
      {
        label: "照片",
        prop: "img",
      }
    ]
  };
};
